import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs/operators";

@Component({
  selector: "app-no-data",
  templateUrl: "./no-data.component.html",
  styleUrls: ["./no-data.component.scss"]
})
export class NoDataComponent implements OnInit {
  title: string;
  constructor(private route: ActivatedRoute) {
    this.route.paramMap
      .pipe(map(() => window.history.state))
      .subscribe(data => {
        this.title = data.title;
      });
  }

  ngOnInit(): void {}
}
